module.exports = __webpack_public_path__ + "img/number.aaa45b23.svg";